
import React from 'react'
import { LinkContainer } from 'react-router-bootstrap'
/* import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons' */
/* import useDarkMode, { DarkModeToggler } from 'use-dark-mode-hook' */


import { Route } from 'react-router-dom'
import { Container, Navbar, Nav, Button } from 'react-bootstrap'
import SearchBox from './SearchBox'




const Header = () => {

    /* const [isDarkMode, toggleDarkMode] = useDarkMode() */



    return (

        <Container className='pt-3'>

            <Navbar>
                <Container className='justify-content-end'>

                    <LinkContainer to='/'>
                        <Navbar.Brand><h1><strong>WittyWeb</strong></h1></Navbar.Brand></LinkContainer>
                    <Route render={({ history }) => <SearchBox history={history} />} />
                    <Nav>
                        <LinkContainer to='/submit'>
                            <Nav.Link><Button className="btn btn-secondary btn-outline-dark" style={{ borderRadius: '0.5em', fontWeight: '600' }}>Submit</Button></Nav.Link></LinkContainer>
                    </Nav>
                    {/* <DarkModeToggler
                        isDarkMode={isDarkMode}
                        toggleDarkMode={toggleDarkMode}
                        buttonClassName="btn"
                    /> */}

                </Container>
            </Navbar>
        </Container>

    )
}

export default Header
